export const getStoredSessionTimeout = () => {
    return parseInt(localStorage.getItem("sessionTimeout"), 10)
}